<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="change-replace"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_864" data-name="Path 864" d="M24,0V24H0V0Z" fill="none" />
    <path
      id="Path_865"
      data-name="Path 865"
      d="M13,15l2.9,2.9L18.8,15"
      transform="translate(0.697 -1.899)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_866"
      data-name="Path 866"
      d="M15,11v8.7"
      transform="translate(1.596 -3.697)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_867"
      data-name="Path 867"
      d="M12.8,13.9,9.9,11,7,13.9"
      transform="translate(-2 -3.697)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
    <path
      id="Path_868"
      data-name="Path 868"
      d="M9,19.7V11"
      transform="translate(-1.101 -3.697)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>
